import { defineFcm } from '../shared/factory';

export const FCM_SIGNATURE_THERMOMETER = defineFcm('signature_thermometer').asBoolean().withDefault(false).toConfig({
	owner: 'squad-vaquita',
	scope: 'corgi-front-end',
	context: 'Petition Gamma Signature Stats',
	description:
		'Enables the signature thermometer component that shows the current amount of signatures in a petition towards the next signature milestone.',
});
